module.exports = __webpack_public_path__ + "img/table_yanfabaoxiao.cadf605b.png";